<!-- 立即兑换, 商品兑换页面 -->
<template>
  <div class="exchange-container">
    <top></top>
    <div class="address-wrapper" @click="selectAddress">
      <div class="left" v-if="address.name">
        <div class="title">
          <div v-if="address.default">默认</div>
          <p>{{address.name}}</p>
          <span>{{address.mobile}}</span>
        </div>
        <p class="region">{{region}}</p>
      </div>
      <div class="select-text" v-else>请选择地址</div>
      <img src="../../assets/icon/icons8-right_4@2x.png">
    </div>
    <div class="line">
      <p v-for="item in 7" :key="item.index">
        <img src="../../assets/icon/2@2x.png">
        <img src="../../assets/icon/3@2x.png">
      </p>
    </div>
    <div class="product-wrapper" v-if="product.id">
      <img :src="product.images.length ? product.images[0] : defaultImg">
      <div class="product-detail">
        <h3>{{product.name}}{{product.spec}}</h3>
        <p>{{product.intro}}</p>
        <p><img src="../../assets/icon/icons8-expensive_2@2x.png"><span>{{product.credit}}</span></p>
      </div>
    </div>
    <div class="product-wrapper" v-if="lottery.id">
      <img :src="lottery.image ? lottery.image : defaultImg">
      <div class="product-detail">
        <h3>{{lottery.name}}</h3>
        <p>{{lottery.intro}}</p>
        <p>价值<span>￥{{lottery.price}}</span></p>
      </div>
    </div>
    <div class="button" @click="toExchange">确认提交</div>
  </div>
</template>

<script>
// import Vue from 'vue'
import { mapGetters } from 'vuex'
import top from '@/components/top'
import qs from 'qs'
import area from '@/util/area'
import { Dialog } from 'vant'
import { Toast } from 'vant'

export default {
  components: { top },
  data() {
    return {
      area: area,
      region: '',
      address: {},
      product: { images: [] },
      lottery: {},
      defaultImg: require('../../assets/img/img_sample.png')
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getAddress()
    if (this.$route.query.productId) {
      this.getProduct()
    }
    if (this.$route.query.lotteryId) {
      this.getLottery()
    }
  },
  methods: {
    getLottery() {
      var that = this
      this.axios.get('/credit/lottery/log/' + this.$route.query.lotteryId + '/').then((res) => {
        console.log(res.data)
        that.lottery = res.data.product
      }).catch((err) => {
        console.log(err)
      })
    },

    getAddress() {
      var that = this
      if (this.$route.query.addressId) {
        this.axios.get('/user/address/' + this.$route.query.addressId).then(function(res) {
          that.address = res.data
          that.region = res.data.province + ' ' + res.data.city + ' ' + res.data.district + ' ' + res.data.address
        }).catch(function(error) {
          console.log(error)
        })
      } else {
        this.axios.get('/user/address').then(function(res) {
          for (const item of res.data.results) {
            if (item.default) {
              that.address = item
              that.region = item.province + ' ' + item.city + ' ' + item.district + ' ' + item.address
            }
          }
        }).catch(function(error) {
          console.log(error)
        })
      }
    },

    getProduct() {
      var that = this
      this.axios.get('/product/' + this.$route.query.productId).then(function(res) {
        that.product = res.data
      }).catch(function(error) {
        console.log(error)
      })
    },

    selectAddress() {
      this.$router.replace({ path: '/user/address', query: { action: 'select', productId: this.$route.query.productId, lotteryId: this.$route.query.lotteryId }})
    },

    /*
      * 点击提交
    **/
    toExchange() {
      if (!this.address.name) {
        return Toast('请选择地址')
      }
      if (this.userInfo.credit < this.product.credit) {
        return Toast(this.userInfo.app.credit_alias + '不足')
      }
      var that = this
      var params = {}
      if (this.product.id) {
        params = {
          name: this.address.name,
          mobile: this.address.mobile,
          address: this.region,
          product: this.$route.query.productId
        }
        Dialog.confirm({
          title: '提示',
          message: '使用' + this.product.credit + this.userInfo.app.credit_alias + '兑换' + this.product.name + '，请确认'
        }).then(() => {
          this.axios.post('/order/', qs.stringify(params)).then(function(res) {
            console.log(res.data)
            if (res.data) {
              Toast('兑换成功')
              that.$store.dispatch('updateCredit', that.userInfo.credit - that.product.credit)
              setTimeout(() => {
                that.$router.replace({ path: '/user/exchange/log' })
              }, 500)
            } else {
              Toast(res.data.detail)
            }
          }).catch(function(error) {
            console.log(error)
            Toast(error.response.data.detail)
          })
        })
      } else {
        params = {
          name: this.address.name,
          mobile: this.address.mobile,
          address: this.region,
          log: this.$route.query.lotteryId
        }
        this.axios.post('/order/lottery/', qs.stringify(params)).then(function(res) {
          console.log(res.data)
          if (res.data) {
            Toast('提交成功')
            setTimeout(() => {
              that.$router.replace({ path: '/activity/log' })
            }, 1000)
          } else {
            Toast(res.data.detail)
          }
        }).catch(function(error) {
          console.log(error.response)
          Toast(error.response.data.detail)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exchange-container{
  .address-wrapper{
    width: 335px;
    height: 73px;
    padding: 0 15px;
    background-color: #ffffff;
    margin: 60px auto 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .title{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 600;
        div{
          width: 31px;
          height: 16px;
          border-radius: 2px;
          background-color: #003485;
          color: #ffffff;
          font-size: 10px;
          font-weight: 400;
          text-align: center;
          line-height: 16px;
          margin-right: 5px;
        }
        p{
          color: #4a4a4a;
          font-size: 14px;
          font-weight: 600;
          margin-right: 5px;
        }
        span{
          color: #747474;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .region{
        width: 300px;
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .select-text{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 600;
    }
    img{
      width: 9px;
      height: 13px;
      opacity: 0.5;
    }
  }
  .line{
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 15px;
    margin: -22px 0 8px;
    p{
      img{
        width: 20px;
        height: 3px;
        margin-right: 3px;
      }
    }
  }
  .product-wrapper{
    width: 345px;
    height: 80px;
    padding: 10px;
    margin: 0 auto;
    background-color: #ffffff;
    display: flex;
    img{
      width: 80px;
      height: 80px;
    }
    .product-detail{
      display: flex;
      margin-left: 10px;
      flex-direction: column;
      justify-content: space-between;
      h3{
        color: #747474;
        font-size: 14px;
        font-weight: 600;
      }
      p{
        display: flex;
        align-items: center;
        img{
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        span{
          color: #f5a623;
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
  }
  .button{
    width: 100%;
    height: 66px;
    background-color: #ff6d63;
    text-align: center;
    line-height: 66px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    position: fixed;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/exchange.vue